import React from 'react'
import { format, parse } from 'date-fns'
import esLocale from 'date-fns/locale/es'
// @ts-ignore
import writtenNumber from 'written-number'
/* import { useEffect, useState } from 'react' */
import DateFnsUtils from '@date-io/date-fns'
import Remove from '@material-ui/icons/Remove'
import { CalendarToday } from '@material-ui/icons'
/* import Autocomplete from '@material-ui/lab/Autocomplete' */
import { IInput, IInputValue } from '../../../types/templates'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers'
import { moneyFormat, numberFormat, validateEmail } from '../../../utils/functions'
import { Checkbox, FormControl, FormHelperText, Grid, Icon, InputAdornment, InputLabel, ListItem, ListItemText, MenuItem, Select, TextField, Typography } from '@material-ui/core'

const FORMAT_STRING = "dd 'de' MMMM 'de' yyyy"

/**
 * define styles for the component
*/
const useStyles = makeStyles((theme: Theme) =>
  createStyles({ 
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      marginBottom: theme.spacing(2),
      width: '100%',
    },
    textAreaList: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      marginBottom: theme.spacing(2),
      width: '100%',
    },
    addButton: {
      maxWidth: '60vw',
      marginBottom: '2vh',
    },
    helperText: {
      margin: 0,
      fontSize: '0.9rem',
      width: '100%',
      padding: '1vh',
      whiteSpace: 'pre-line',
      textAlign: 'justify'
    },
  })
)
// Define IError interface
interface IError {
  error: boolean
  label: string
}

/**
 * Custom `InputItem` component declaration.
 * This component is used to define functionalities for each type of input
 *@param {Object} inputError,
 *@param {Function} setInputError,
 *@param {Object} input,
 *@param {Number} pos,
 *@param {Array} inputValues,
 *@param {Function} setInputValues,
 *@param {Any} inputsConfig,
 * @return InputItem
*/
const InputItem = ({
  inputError,
  setInputError,
  input,
  pos,
  inputValues,
  setInputValues,
  inputsConfig,
}: {
  inputError: IError
  setInputError: (newState: IError) => void
  input: IInput
  pos: number
  inputValues: IInputValue[]
  setInputValues: (newValue: IInputValue[]) => void
  inputsConfig: any
}): JSX.Element => {
  const classes = useStyles()
  /* const [sugges, setSugges] = useState<string[]>([])

  useEffect(() => {
    const fetchTemplatesActive = () => {
      if (input && input.suggestions ) {
        setSugges(input.suggestions.split(","))
      }
    }
    fetchTemplatesActive()
  }, []) */
  
  /**
   * This method is to validate if the format text is correct and if it is, add it
   * @param {Unknow} value
   * @Return {void}
  */
  const onChangeText = (event: React.ChangeEvent<{ value: unknown }>) => {
    const value = event.target.value as string
    /* if (value === '')
      setInputError({ error: true, label: 'Ingrese un valor válido' })
    else  */
    setInputError({ error: false, label: '' })
    inputsConfig.setInputValue({
      uid: input.uid,
      value,
      noFormatValue: value,
      type: input.type,
      options: input.options,
      pos,
    })
  }

  /**
   * This method is to validate if the format email is correct and if it is, add it
   * @param {Unknow} value
   * @Return {void}
  */
  const onChangeEmail = (event: React.ChangeEvent<{ value: unknown }>) => {
    const value = event.target.value as string
    if (/* value === '' ||  */validateEmail(value) === false)
      setInputError({ error: true, label: 'Ingrese un correo válido' })
    else setInputError({ error: false, label: '' })
    inputsConfig.setInputValue({
      uid: input.uid,
      value,
      noFormatValue: value,
      type: input.type,
      options: input.options,
      pos,
    })
  }

  /**
   * This method is to validate if the format sign is correct and if it is, add it
   * @param {Unknow} value
   * @Return {void}
  */
  const onChangeSign = (event: React.ChangeEvent<{ value: unknown }>) => {
    const value = event.target.value as string
    /* if (value === '')
      setInputError({ error: true, label: 'Ingrese un valor válido' })
    else  */
    setInputError({ error: false, label: '' })
    inputsConfig.setInputValue({
      uid: input.uid,
      value,
      noFormatValue: value,
      type: input.type,
      options: input.options,
      pos,
    })
  }

  /**
   * This method is to validate if the format date is correct and if it is, add it
   * @param {Date} value
   * @Return {void}
  */
  const handleDateChange = (date: Date | null) => {
    if (!date) setInputError({ error: true, label: 'Ingrese un valor válido' })
    else setInputError({ error: false, label: '' })
    inputsConfig.setInputValue({
      uid: input.uid,
      value: date
        ? format(date, FORMAT_STRING, { locale: esLocale })
        : format(new Date(), FORMAT_STRING, { locale: esLocale }),
      noFormatValue: date,
      type: input.type,
      options: input.options,
      pos,
    })
    const newInputs = inputValues.filter(
      (i: IInputValue) => i.uid !== input.uid
    )
    newInputs.push({
      uid: input.uid,
      value: date
        ? format(date, FORMAT_STRING, { locale: esLocale })
        : format(new Date(), FORMAT_STRING, { locale: esLocale }),
      noFormatValue: date,
      type: input.type,
      options: input.options,
      pos,
    })
    setInputValues(newInputs)
  }


  const onBlurEnd = () => {
    if (inputsConfig.inputValue) {
      const newInputs = inputValues.filter(
        (i: IInputValue) => i.uid !== inputsConfig.inputValue.uid
      )
      newInputs.push(inputsConfig.inputValue)
      setInputValues(newInputs)
    }
  }

  /**
   * This method is to validate if the format money is correct and if it is, add it
   * @Return {void}
  */
  const onBlurEndMoney = () => {
    if (inputsConfig.inputValue) {
      const newInputs = inputValues.filter(
        (i: IInputValue) => i.uid !== inputsConfig.inputValue.uid
      )
      newInputs.push({
        ...inputsConfig.inputValue,
        value: `${
          moneyFormat(inputsConfig.inputValue.value) as string
        } ${writtenNumber(inputsConfig.inputValue.value, {
          lang: 'es',
        })} pesos`,
        noFormatValue: inputsConfig.inputValue.value,
      })
      setInputValues(newInputs)
    } else {
      setInputError({ error: true, label: 'Ingrese un valor de moneda válido' })
    }
  }

  /**
   * This method is to validate if the format number is correct and if it is, add it
   * @Return {void}
  */
  const onBlurEndNumber = () => {
    if (inputsConfig.inputValue) {
      const newInputs = inputValues.filter(
        (i: IInputValue) => i.uid !== inputsConfig.inputValue.uid
      )
      newInputs.push({
        ...inputsConfig.inputValue,
        value: `${numberFormat(inputsConfig.inputValue.value) as string}`,
        noFormatValue: inputsConfig.inputValue.value,
      })
      setInputValues(newInputs)
    } else {
      setInputError({ error: true, label: 'Ingrese un valor numérico válido' })
    }
  }

  /**
   * This method is to count the list item
   * @param {Array} stringArray
   * @Return {void}
  */
  const stringListFormat = (stingArray: string[]) => {
    let stringList = ''
    let countItem: number = input.startWith || 0
    for (const itemText of stingArray) {
      stringList += `<p>${countItem}. ${itemText} <br></p>`
      countItem++
    }
    return stringList
  }

  /**
   * This method is to add input to the list
   * @param {Number} index
   * @param {String} value
   * @Return {void}
  */
  const onChangeList = (index: number, value: string) => {
    /* if (value === '')
      setInputError({
        error: true,
        label: 'Los elementos de la lista no pueden estar en blanco',
      })
    else  */
    setInputError({ error: false, label: '' })
    const newArrayList = inputsConfig.inputValue.noFormatValue
    newArrayList[index] = value
    inputsConfig.setInputValue({
      ...inputsConfig.inputValue,
      uid: input.uid,
      type: input.type,
      options: input.options,
      pos,
      value: stringListFormat(newArrayList),
      noFormatValue: newArrayList,
    })
  }


  const onBlurList = () => {
    const newInputs = inputValues.filter(
      (i: IInputValue) => i.uid !== input.uid
    )
    newInputs.push(inputsConfig.inputValue)
    setInputValues(newInputs)
  }

  /**
   * This method is to add input to the multiselect
   * @param {Unknown} value
   * @Return {void}
  */
  const onChangeMultiSelect = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const newArrayList = event.target.value as string[]
    /* if (newArrayList.length === 0)
      setInputError({
        error: true,
        label: 'Debes seleccionar al menos un elemento',
      })
    else  */
    setInputError({ error: false, label: '' })
    inputsConfig.setInputValue({
      ...inputsConfig.inputValue,
      uid: input.uid,
      type: input.type,
      options: input.options,
      pos,
      value: newArrayList.join(', '),
      noFormatValue: newArrayList,
    })
    const newInputs = inputValues.filter(
      (i: IInputValue) => i.uid !== input.uid
    )
    newInputs.push({
      ...inputsConfig.inputValue,
      uid: input.uid,
      type: input.type,
      options: input.options,
      pos,
      value: newArrayList.join(', '),
      noFormatValue: newArrayList,
    })
    setInputValues(newInputs)
  }

  /**
   * This method is to add input to the select
   * @param {Unknown} value
   * @Return {void}
  */
  const onChangeSelect = (event: React.ChangeEvent<{ value: unknown }>) => {
    const value = event.target.value as string
    /* if (value === '')
      setInputError({ error: true, label: 'Ingrese un valor válido' })
    else  */
    setInputError({ error: false, label: '' })
    inputsConfig.setInputValue({
      uid: input.uid,
      value,
      noFormatValue: event.target.value,
      type: input.type,
      options: input.options,
      pos,
    })
    const newInputs = inputValues.filter(
      (i: IInputValue) => i.uid !== input.uid
    )
    newInputs.push({
      uid: input.uid,
      value,
      noFormatValue: event.target.value,
      type: input.type,
      options: input.options,
      pos,
    })
    setInputValues(newInputs)
  }

  /* const onChangeAutoComplete = (_: any, value: any) => {
    setInputError({ error: false, label: '' })
    inputsConfig.setInputValue({
      uid: input.uid,
      value,
      noFormatValue: value,
      type: input.type,
      options: input.options,
      pos,
    })
  } */

  // Define style and functionalities to Inputs 
  switch (input.type) {
    case 'text':
      return (
        /* <Autocomplete
          freeSolo
          options={sugges}
          value={inputsConfig.inputValue ? inputsConfig.inputValue.noFormatValue : ''}
          getOptionLabel={(option) => option}
          /* onInputChange={(_, value) => {
            onChangeAutoComplete(_, value)
          }} *
          renderInput={(params) => {
            return ( */<TextField
              /* {...params} */
              className={classes.textField}
              style={{ fontSize: '1px' }}
              id={`input${input.uid}`}
              value={inputsConfig.inputValue ? inputsConfig.inputValue.noFormatValue : ''}
              label={input.label}
              variant="outlined"
              onChange={onChangeText}
              onBlur={onBlurEnd}
              error={inputError.error}
              helperText={inputError.error ? inputError.label : input.info}
              FormHelperTextProps={{
                className: classes.helperText,
              }}
          />/* ) }}
        /> */
      )
    case 'email':
      return (
        /* <Autocomplete
          freeSolo
          options={sugges}
          value={inputsConfig.inputValue ? inputsConfig.inputValue.noFormatValue : ''}
          getOptionLabel={(option) => option}
          /* onInputChange={(_, value) => {
            onChangeAutoComplete(_, value)
          }} *
          renderInput={(params) => {
            return ( */<TextField
              /* {...params} */
              className={classes.textField}
              style={{ fontSize: '1px' }}
              id={`input${input.uid}`}
              value={inputsConfig.inputValue ? inputsConfig.inputValue.noFormatValue : ''}
              label={input.label}
              variant="outlined"
              onChange={onChangeEmail}
              onBlur={onBlurEnd}
              error={inputError.error}
              helperText={inputError.error ? inputError.label : input.info}
              FormHelperTextProps={{
                className: classes.helperText,
              }}
          />/* ) }}
        /> */
      )
    case 'sign':
      return (
        <TextField
          className={classes.textField}
          style={{ fontSize: '1px' }}
          id={`input${input.uid}`}
          value={inputsConfig.inputValue ? inputsConfig.inputValue.value : ''}
          label={input.label}
          variant="outlined"
          onChange={onChangeSign}
          onBlur={onBlurEnd}
          error={inputError.error}
          helperText={inputError.error ? inputError.label : input.info}
          FormHelperTextProps={{
            className: classes.helperText,
          }}
        />
      )
    case 'select':
      return (
        <TextField
          className={classes.textField}
          id="selectinput"
          select
          label={input.label}
          value={
            inputsConfig.inputValue ? inputsConfig.inputValue.noFormatValue : ''
          }
          onChange={onChangeSelect}
          variant="outlined"
          error={inputError.error}
          helperText={inputError.error ? inputError.label : input.info}
          FormHelperTextProps={{
            className: classes.helperText,
          }}
        >
          {input.options?.split(',').map((input: string, index: number) => (
            <MenuItem key={index} value={index}>
              {input}
            </MenuItem>
          ))}
        </TextField>
      )
    case 'date':
      return (
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
          <DatePicker
            variant="inline"
            openTo="date"
            format={FORMAT_STRING}
            autoOk
            className={classes.textField}
            id={`input${input.uid}`}
            value={
              inputsConfig.inputValue
                ? parse(
                    inputsConfig.inputValue.value,
                    FORMAT_STRING,
                    new Date(),
                    {
                      locale: esLocale,
                    }
                  )
                : null
            }
            label={input.label}
            inputVariant="outlined"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <CalendarToday />
                </InputAdornment>
              ),
            }}
            onChange={handleDateChange}
            error={inputError.error}
            helperText={inputError.error ? inputError.label : input.info}
            FormHelperTextProps={{
              className: classes.helperText,
            }}
          />
        </MuiPickersUtilsProvider>
      )
    case 'money':
      return (
        /* <Autocomplete
          freeSolo
          options={sugges}
          value={inputsConfig.inputValue ? inputsConfig.inputValue.noFormatValue : ''}
          getOptionLabel={(option) => option}
          /* onInputChange={(_, value) => {
            onChangeAutoComplete(_, value)
          }} *
          renderInput={(params) => {
            return ( */<TextField
            /* {...params} */
              className={classes.textField}
              id={`input${input.uid}`}
              value={
                inputsConfig.inputValue ? inputsConfig.inputValue.noFormatValue : ''
              }
              label={input.label}
              variant="outlined"
              type="number"
              onChange={onChangeText}
              onBlur={onBlurEndMoney}
              error={inputError.error}
              helperText={
                inputError.error
                  ? inputError.label
                  : input.info +
                    ' ' +
                    `${moneyFormat(
                      inputsConfig.inputValue
                        ? inputsConfig.inputValue.noFormatValue
                        : 0
                    )} ${
                      inputsConfig.inputValue
                        ? writtenNumber(inputsConfig.inputValue.value, {
                            lang: 'es',
                          }) + ' pesos'
                        : ''
                    } `
              }
              FormHelperTextProps={{
                className: classes.helperText,
              }}
          />/* ) }}
        /> */
      )
    case 'number':
      return (
        /* <Autocomplete
          freeSolo
          options={sugges}
          value={inputsConfig.inputValue ? inputsConfig.inputValue.noFormatValue : ''}
          getOptionLabel={(option) => option}
          /* onInputChange={(_, value) => {
            onChangeAutoComplete(_, value)
          }} *
          renderInput={(params) => {
            return ( */<TextField
              /* {...params} */
              className={classes.textField}
              id={`input${input.uid}`}
              value={
                inputsConfig.inputValue ? inputsConfig.inputValue.noFormatValue : ''
              }
              label={input.label}
              variant="outlined"
              type="number"
              onChange={onChangeText}
              onBlur={onBlurEndNumber}
              error={inputError.error}
              helperText={
                inputError.error
                  ? inputError.label
                  : input.info +
                    ' ' +
                    numberFormat(
                      inputsConfig.inputValue
                        ? inputsConfig.inputValue.noFormatValue
                        : 0
                    )
              }
              FormHelperTextProps={{
                className: classes.helperText,
              }}
          />/* ) }}
        /> */
      )
    case 'list':
      return (
        <Grid item xs={12} sm={12} md={12}>
          <Typography
            variant="h6"
            align="center"
            paragraph
            style={{
              marginBottom: '0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: inputError.error ? 'red' : 'black',
            }}
          >
            {input.label}
            <Icon
              style={{ marginLeft: '1vh' }}
              color="primary"
              onClick={() => {
                if (inputsConfig.inputValue) {
                  if (inputsConfig.inputValue.noFormatValue.includes('')) {
                    setInputError({
                      error: true,
                      label:
                        'Los elementos de la lista no pueden estar en blanco',
                    })
                    return
                  } else setInputError({ error: false, label: '' })

                  inputsConfig.setInputValue({
                    ...inputsConfig.inputValue,
                    value: stringListFormat([
                      ...inputsConfig.inputValue.noFormatValue,
                      '',
                    ]),
                    noFormatValue: [
                      ...inputsConfig.inputValue.noFormatValue,
                      '',
                    ],
                  })
                } else
                  inputsConfig.setInputValue({
                    uid: input.uid,
                    type: input.type,
                    options: input.options,
                    pos,
                    value: stringListFormat(['']),
                    noFormatValue: [''],
                  })
              }}
            >
              add_circle
            </Icon>
          </Typography>
          {inputError.error && (
            <Typography
              variant="body1"
              align="center"
              paragraph
              style={{ marginBottom: 0, color: 'red' }}
            >
              {inputError.label}
            </Typography>
          )}
          <Typography
            variant="body1"
            align="center"
            color="textSecondary"
            paragraph
            style={{ marginBottom: '2vh', whiteSpace: 'pre-line' }}
          >
            {input.info}
          </Typography>

          {inputsConfig.inputValue?.noFormatValue?.length > 0 && (
            <ListItem
              alignItems="flex-start"
              style={{
                display: 'flex',
                flex: 1,
                justifyContent: 'space-between',
                borderStyle: 'solid',
                borderWidth: 2,
                borderRadius: 10,
                borderColor: '#0A3740',
                marginBottom: '1vh',
              }}
            >
              <Grid
                container
                spacing={1}
                justifyContent={'center'}
                alignItems={'center'}
              >
                {typeof(inputsConfig.inputValue.noFormatValue) === 'string' ? '' : 
                  inputsConfig.inputValue.noFormatValue.map(
                  (data: string, index: number) => {
                    const arrayData = inputsConfig.inputValue.noFormatValue
                    return (
                      <React.Fragment key={index}>
                        <Grid item xs={2} sm={2} md={2} lg={2}>
                          <h5
                            style={{ marginRight: '2vw', textAlign: 'center' }}
                          >
                            {(input.startWith || 1) + index}
                          </h5>
                        </Grid>
                        <Grid item xs={8} sm={8} md={8} lg={8}>
                          <TextField
                            key={index}
                            style={{ width: '100%' }}
                            id={`input${input.uid}${index}`}
                            value={data}
                            variant="outlined"
                            multiline
                            rows={2}
                            onChange={(
                              event: React.ChangeEvent<{ value: unknown }>
                            ) =>
                              onChangeList(index, event.target.value as string)
                            }
                            onBlur={onBlurList}
                          />
                        </Grid>
                        <Grid item xs={2} sm={2} md={2} lg={2}>
                          <Remove
                            style={{ textAlign: 'center' }}
                            onClick={() => {
                              if (
                                arrayData.includes('') &&
                                arrayData[index] !== ''
                              ) {
                                setInputError({
                                  error: true,
                                  label:
                                    'Los elementos de la lista no pueden estar en blanco',
                                })
                                return
                              } else setInputError({ error: false, label: '' })
                              const newArrayList = arrayData
                              newArrayList.splice(index, 1)
                              inputsConfig.setInputValue({
                                ...inputsConfig.inputValue,
                                value: stringListFormat([...newArrayList]),
                                noFormatValue: [...newArrayList],
                              })
                              const newInputs = inputValues.filter(
                                (i: IInputValue) => i.uid !== input.uid
                              )
                              newInputs.push({
                                ...inputsConfig.inputValue,
                                value: stringListFormat([...newArrayList]),
                                noFormatValue: [...newArrayList],
                              })
                              setInputValues([...newInputs])
                              if (newArrayList.length === 0)
                                setInputError({ error: false, label: '' })
                            }}
                          />
                        </Grid>
                      </React.Fragment>
                    )
                  }
                )}
              </Grid>
            </ListItem>
          )}
        </Grid>
      )

    case 'multiselect':
      return (
        <FormControl
          className={classes.textField}
          variant="outlined"
          error={inputError.error}
        >
          <InputLabel
            id={`multiselect${input.uid}`}
            htmlFor="outlined-age-native-simple"
          >
            {input.label}
          </InputLabel>
          <Select
            multiple
            label={input.label}
            value={
              inputsConfig.inputValue
                ? inputsConfig.inputValue.noFormatValue instanceof Array ? inputsConfig.inputValue.noFormatValue : []
                : []
            }
            onChange={onChangeMultiSelect}
            renderValue={(selected) => {
              //asegurarme que sea string o arreglo
              return (selected as string[]).join(', ')}}
          >
            {input.options?.split(',').map((input: string, index: number) => (
              <MenuItem key={index} value={input.trim()}>
                <Checkbox
                  color="primary"
                  checked={
                    (inputsConfig.inputValue
                      ? inputsConfig.inputValue.noFormatValue instanceof Array ? inputsConfig.inputValue.noFormatValue : []
                      : []
                    ).indexOf(input.trim()) > -1
                  }
                />
                <ListItemText primary={input.trim()} />
              </MenuItem>
            ))}
          </Select>
          <FormHelperText className={classes.helperText}>
            {inputError.error ? inputError.label : input.info}
          </FormHelperText>
        </FormControl>
      )

    default:
      return <></>
  }
}

export default InputItem